import React from "react";
import "./RoadTransport.css";
import Arab from "../../../../../Image/Arab.png";
import Dubai from "../../../../../Image/dubai.png";
import footprint from "../../../../../Image/footprint.png";
import useFetch from "../../../../../hooks/useFetch";
import { Link } from "react-router-dom";

const Draft = () => {
  const { data } = useFetch("https://abc-backend.onrender.com/api/quotes");
  console.log(data);
  return (
    <div className="tabelMain">
      {data?.map((item, i) => (
        <>
          {item.saveDrfat && (
            <div className="card" style={{ marginBottom: "20px" }} key={i}>
              <div className="card-heading card-heading1">
                <div>
                  <h5>ID</h5>
                </div>
                <div>
                  <h5 className="countryTitle">
                    {item?.data?.loadingUnDetailsValue[0]?.locationFrom}
                    {"  "}
                    {item?.data?.loadingUnDetailsValue[0]?.locationTo}
                  </h5>
                </div>
                <div>
                  <Link to={`/request-a-quote/${item._id}`}>
                    <button className="draft_edit_btn">Edit</button>
                  </Link>
                </div>
              </div>
              <div className="card-heading">
                <div>
                  <h5>100001</h5>
                  <h5>13-Sep-2022 07:05</h5>
                  <h5>{item?.data?.quoteIntValue?.transportationType}</h5>
                </div>
                <div>
                  <h6>Services:</h6>
                  <h6>Product:</h6>
                  <h6>Loading Date:</h6>
                </div>
                <div>
                  <h5>Road Transportation</h5>
                  <h5>{item?.data?.quoteIntValue?.productType}</h5>
                  <h5>{item?.data?.quoteIntValue?.loadDate}</h5>
                </div>
                <div className="footprint_img">
                  <img src={footprint} alt="footprint" />
                  <span>100 g</span>
                </div>
              </div>
              {item?.data?.loadingUnDetailsValue.map((lcData, i) => (
                <div className="card-heading" key={i}>
                  <div>
                    <h5> {lcData.locationFrom}</h5>
                    <h6 className="country"> {lcData.locationFrom}</h6>
                    <img width="40" height="25" src={Dubai} alt="" />
                    <h5>Pickup</h5>
                  </div>
                  {/* <div>
                  <h5> {lcData.locationFrom}</h5>
                  <h6 className="country">United Arab Emirates</h6>
                  <img width="40" height="25" src={Dubai} alt="" />
                  <h5>Un-Loading</h5>
                </div> */}
                  {/* <div>
                  <h5> {lcData.locationTo}</h5>
                  <h6 className="country">
                    {lcData.locationTo}
                  </h6>
                  <img width="40" height="25" src={Arab} alt="" />
                  <h5>Un-Loading</h5>
                </div> */}
                  <div>
                    <h5>{lcData.locationTo}</h5>
                    <h6 className="country">{lcData.locationTo}</h6>
                    <img width="40" height="25" src={Arab} alt="" />
                    <h5>Destination</h5>
                  </div>
                </div>
              ))}
              <div className="user_dashboard_line"></div>
            </div>
          )}
        </>
      ))}
    </div>
  );
};

export default Draft;
